import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApiService, Usuario } from '../../api.service';

export type EstadoUsuarioCadastro = {
  usuarioSelecionado: string;
  usuario: Usuario;
};

@Injectable({ providedIn: 'root' })
export class ServicoUsuarioAdministrativo {
  constructor(private readonly api: ApiService) {}

  novoUsuario(empregadorId = ''): Usuario {
    return {
      nome: '',
      email: '',
      senha: '',
      perfil: 'ADMIN_EMPREGADOR',
      departamentoId: '',
      departamentoIds: [],
      empregadorId,
      ativo: true
    };
  }

  prepararEdicao(usuario: Usuario | undefined, empregadorId: string): Usuario {
    if (!usuario) {
      return this.novoUsuario(empregadorId);
    }

    return {
      ...usuario,
      empregadorId: usuario.empregador?.id || empregadorId,
      departamentoId: usuario.departamentoId || '',
      departamentoIds: this.departamentoIdsUsuario(usuario),
      senha: ''
    };
  }

  prepararSalvar(usuario: Usuario, empregadorId: string): Usuario {
    return {
      ...usuario,
      empregadorId: usuario.perfil === 'ADMIN_GLOBAL' ? undefined : empregadorId,
      departamentoId: undefined,
      departamentoIds: usuario.perfil === 'ADMIN_GLOBAL' ? [] : usuario.departamentoIds || []
    };
  }

  private departamentoIdsUsuario(usuario: Usuario) {
    if (usuario.departamentoIds?.length) {
      return [...usuario.departamentoIds];
    }
    if (usuario.departamentoId) {
      return [usuario.departamentoId];
    }
    return [];
  }

  estadoLimpo(empregadorId: string): EstadoUsuarioCadastro {
    return {
      usuarioSelecionado: '',
      usuario: this.novoUsuario(empregadorId)
    };
  }

  estadoSelecionado(usuarios: Usuario[], usuarioId: string, empregadorId: string): EstadoUsuarioCadastro {
    const selecionado = usuarios.find(item => item.id === usuarioId);
    return {
      usuarioSelecionado: usuarioId,
      usuario: this.prepararEdicao(selecionado, empregadorId)
    };
  }

  listar(empregadorId?: string): Observable<Usuario[]> {
    return this.api.listarUsuarios(empregadorId);
  }

  listarPorEmpregadorSelecionado(_empregadorId: string): Observable<Usuario[]> {
    return this.listar();
  }

  salvar(usuario: Usuario): Observable<Usuario> {
    return this.api.salvarUsuario(usuario);
  }

  excluir(usuarioId: string): Observable<void> {
    return this.api.excluirUsuario(usuarioId);
  }

  mensagemErroCarregarUsuarios() {
    return 'Nao foi possivel carregar usuarios.';
  }

  mensagemUsuarioSalvo(_usuario: Usuario, editando = false) {
    return editando
      ? 'Sucesso.\nRegistro alterado com sucesso.'
      : 'Sucesso.\nRegistro salvo com sucesso.';
  }

  mensagemErroSalvar() {
    return 'Erro ao salvar usuario.';
  }

  mensagemConfirmarExclusao() {
    return 'Confirma excluir este usuario?';
  }

  mensagemUsuarioExcluido() {
    return 'Sucesso.\nRegistro excluído com sucesso.';
  }

  mensagemErroExcluir() {
    return 'Erro ao excluir usuario.';
  }
}
